import { envUtils } from "./envUtils";

/**
 * Returns the link to a space with the provided space id.
 *
 * @param {string|undefined} spaceId The id of the space to get the link to.
 *
 * @returns {string}
 */
export const getCADchatSpaceLink = (spaceId: string | undefined, includeQueryParams = true) => {
  const baseUrl = envUtils.CADCHAT_APP_BASE_URL;
  if (!baseUrl || !spaceId) return undefined;

  return includeQueryParams
    ? `${baseUrl}/spaces/space/${spaceId}?login_flow=pre_meeting`
    : `${baseUrl}/spaces/space/${spaceId}`;
};

/**
 * Constructs a local URL for the web page for the given path.
 * @param path The path to construct a local URL for.
 * @returns
 */
export function createLocalUrl(path: string) {
  return `${window.location.origin}/${path}`;
}

export function isEmail(str: string): boolean {
  const COMPLEX_EMAIL_REGEX =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  const SIMPLE_EMAIL_REGEX = /\S+@\S+\.\S+/;

  return COMPLEX_EMAIL_REGEX.test(str) && SIMPLE_EMAIL_REGEX.test(str);
}

/**
 * Returns `true` if the value is not `null` or `undefined`.
 *
 * @param {TValue|null|undefined} value The value to check.
 *
 * @returns {value is TValue} Returns `true` if the value is not `null` or `undefined`.
 */
export const notEmpty = <TValue>(value: TValue | null | undefined): value is TValue => {
  return value !== null && value !== undefined;
};
